import sectionFreestyleInfoCss from '../css-snippets/section-freestyle-info';

const html = ` 
<style>${sectionFreestyleInfoCss}</style>
<div
  id="freestyle-info-wrapper-unique-id"
  data-id="unique-id"
  class="freestyle-info-wrapper"
  data-attribute="freestyle-info-wrapper"
  data-background-color="#ffffff"
  data-text-color="#000000"
  data-table-header-background-color="#14a16c"
  data-table-header-text-color="#ffffff"
  data-table-old-row-background-color="#d6dad9"
  data-table-old-row-text-color="#000000"
  data-top-padding="true"
  data-bottom-padding="true"
  style="
    --background-color: #ffffff;
    --text-color: #000000;
    --table-header-background-color: #14a16c;
    --table-header-text-color: #ffffff;
    --table-old-row-background-color: #d6dad9;
    --table-old-row-text-color: #000000;
  "
>
  <div
    data-attribute="freestyle-info-container"
    class="freestyle-info-container"
  >
    <div
      class="freestyle-info-product-facts-wrapper"
      data-attribute="freestyle-info-product-facts-wrapper"
    >
      <div
        class="freestyle-info-image-2"
        data-attribute="freestyle-info-image-2"
      >
        <img
          data-attribute="freestyle-info-image-2-inner"
          src="https://cdn.skyfastimg.com/images/2026/09/21/image-6ab0dc7eb0716980c1ed718d.png?w=500"
          alt="img"
        />
      </div>
      <div class="freestyle-info-product-facts-content container">
        <div
          class="freestyle-info-product-facts"
          data-attribute="freestyle-info-product-facts"
        >
          <h2 style="text-align: center"><strong>Product Facts</strong></h2>
          <ul>
            <li>
              <strong>One (1) bottle contains 60 chewable tablets.</strong>
            </li>
            <li>
              <strong>
                Each chewable tablet contains 200 mg of Organic Tiger Milk
                Mushroom.
              </strong>
            </li>
            <li>
              <strong>Active Ingredient:</strong>
              <span> Organic Tiger Milk Mushroom.</span>
            </li>
            <li>
              <strong>Inactive Ingredients:</strong>
              <span>
                Granulac, Microcrystalline Cellulose, Maltodextrin, Magnesium
                Stearate.
              </span>
            </li>
            <li>
              <strong>Flavor:</strong>
              <span> Savory umami flavor that pets love.</span>
            </li>
          </ul>
        </div>
      </div>
    </div>
    <div class="freestyle-info-images" data-attribute="freestyle-info-images">
      <div
        class="freestyle-info-image-1"
        data-attribute="freestyle-info-image-1"
      >
        <img
          data-attribute="freestyle-info-image-1-inner"
          src="https://cdn.skyfastimg.com/images/2026/09/21/image-6ab0dc82fc7d0c4982d4bc45.png?w=500"
          alt="img"
        />
      </div>
      <div
        class="freestyle-info-image-2"
        data-attribute="freestyle-info-image-2"
      >
        <img
          data-attribute="freestyle-info-image-2-inner"
          src="https://cdn.skyfastimg.com/images/2026/09/21/image-6ab0dc7eb0716980c1ed718d.png?w=500"
          alt="img"
        />
      </div>
    </div>
    <div
      class="freestyle-info-direction-for-use-wrapper"
      data-attribute="freestyle-info-direction-for-use-wrapper"
    >
      <div
        class="freestyle-info-image-1"
        data-attribute="freestyle-info-image-1"
      >
        <img
          data-attribute="freestyle-info-image-1-inner"
          src="https://cdn.skyfastimg.com/images/2026/09/21/image-6ab0dc82fc7d0c4982d4bc45.png?w=500"
          alt="img"
        />p
      </div>
      <div class="freestyle-info-direction-for-use-content container">
        <div
          class="freestyle-info-direction-for-use"
          data-attribute="freestyle-info-direction-for-use"
        >
          <h2 style="text-align: center"><strong>Direction For Use</strong></h2>
          <ul>
            <li>
              <strong>One (1) tablet per 30 lbs of body weight daily.</strong>
            </li>
            <li>
              <span>For dogs and cats.</span>
            </li>
            <li>
              <span>Suitable for all breeds and all ages.</span>
            </li>
            <li>
              <span>Allow four to six weeks for best results.</span>
            </li>
            <li>
              <span>Individual results may vary.</span>
            </li>
          </ul>
        </div>
      </div>
    </div>
    <div
      class="freestyle-info-table-content container"
      data-attribute="freestyle-info-table-content"
    >
      <div class="freestyle-info-table" data-attribute="freestyle-info-table">
        <figure class="table" style="width: 100%">
          <table class="ck-table-resized">
            <colgroup>
              <col style="width: 50%" />
              <col style="width: 50%" />
            </colgroup>
            <thead>
              <tr>
                <th>
                  <p style="text-align: center">
                    <span><strong>WEIGHT</strong></span>
                  </p>
                </th>
                <th>
                  <p style="text-align: center">
                    <span><strong>NO. OF TABLETS</strong></span>
                  </p>
                </th>
              </tr>
            </thead>
            <tbody>
              <tr>
                <td>
                  <p style="text-align: center">Below 30 lbs</p>
                </td>
                <td>
                  <p style="text-align: center">Half A Tablet Daily</p>
                </td>
              </tr>
              <tr>
                <td>
                  <p style="text-align: center">
                    <span>30 to 45 lbs</span>
                  </p>
                </td>
                <td>
                  <p style="text-align: center">
                    <span>1 Tablet Daily</span>
                  </p>
                </td>
              </tr>
              <tr>
                <td>
                  <p style="text-align: center">46 lbs and above</p>
                </td>
                <td>
                  <p style="text-align: center">
                    <span>2 Tablets Daily</span>
                  </p>
                </td>
              </tr>
            </tbody>
          </table>
        </figure>
      </div>
    </div>
  </div>
</div>
`;
export default html;
